import {SpaceProto} from "../space-proto";
import {NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGeneric from "../../../../layout/navigation/buttons/generic";
import {getNavigationPosition} from "../../navigation/functions/get-navigation-position";
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click";
import MainMenu_Reports from "../../../../layout/menu/sections/reports/reports";
import ProjectSession from "../../project/project-session";
import {ProjectSystemType} from "../../project/types";


export class SpaceReports extends SpaceProto {

    constructor() {
        super(NavigationSectionType.REPORTS)

        this.title      = "Reports"
        this.svgIcon    = "isvg-reports-space"
    }

    get navigationStructureConfig() {
        return {
            id              : this.id,
            icon            : "i5-chart-bar",
            hint            : "Reports",
            menuComponent   : MainMenu_Reports,
            renderComponent : Navigation_ButtonGeneric,
            type            : NavigationSectionType.REPORTS,
            onClick         : navigationStructureOnClick,
            position        : getNavigationPosition(NavigationSectionType.REPORTS)
        }
    }

    get reports() {

        const filteredReports: ProjectSession[] = []

        gd.session.projects.models.map((project: ProjectSession)=> {

            if(project.systemType === ProjectSystemType.REPORT_VIEW){
                filteredReports.push(project)
            }
        })

        return filteredReports
    }

}
